import { useState } from 'react';
import { useScrollAnimation, getStaggerProps, animationClasses } from '@/hooks/useScrollAnimation';

const faqs = [
  {
    question: '財經錢線出版哪些類型的書？',
    answer: '財經錢線主要出版財經知識、商業理財、投資觀念、金錢思維、經濟趨勢、企業經營與職場收入相關作品。',
  },
  {
    question: '財經錢線適合哪些讀者？',
    answer: '財經錢線適合想理解財經知識、建立理財觀念、關注市場變化、商業思維、經濟趨勢與個人財務選擇的讀者。',
  },
  {
    question: '財經錢線和崧博出版是什麼關係？',
    answer: '財經錢線為崧博出版經銷品牌之一，主要聚焦財經、商業與理財類出版內容，由崧博出版事業有限公司負責經銷與通路發行。',
  },
  {
    question: '財經錢線的內容是投資建議嗎？',
    answer: '不是。財經錢線網站內容以書籍導讀與財經閱讀整理為目的，不構成投資、理財、稅務、法律或其他專業建議。',
  },
];

export default function HomeFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="min-h-[100svh] flex items-center bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          {/* Title */}
          <div className={`text-center mb-10 ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3">
              常見問答
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3 tracking-tight">
              關於財經錢線，你可能想知道
            </h2>
          </div>

          {/* FAQ items — each with individual stagger */}
          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                {...getStaggerProps(isVisible, index, 200)}
                className="rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left bg-background-100 hover:bg-background-200/50 transition-colors"
                >
                  <span className="font-medium text-foreground-800 text-sm pr-4">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i
                      className={`ri-arrow-down-s-line text-foreground-400 transition-transform ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="p-5 pt-0 text-sm text-foreground-600 leading-relaxed text-left bg-background-100">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}